import istor from '../Assets/istor2.png';
import ministor from '../Assets/ministor.png';
import { useState } from 'react';
import { useMediaQuery } from '../useMediaQuery';
import { EyeOff, EyeOn } from '../PasswordEye';

const CONTENT = {
    title: '\u201cJe vous \u00e9coute\u00a0!',
    message: 'Cr\u00e9ez un mot de passe s\u00e9curis\u00e9.\nN\u2019h\u00e9sitez pas \u00e0 y m\u00ealer des caract\u00e8res\nsp\u00e9ciaux, des chiffres..."',
    short: 'Cr\u00e9ez un mot de passe s\u00e9curis\u00e9.\nN\u2019h\u00e9sitez pas \u00e0 y m\u00ealer des caract\u00e8res sp\u00e9ciaux, des chiffres...\u201d',
};


const ERROR_MESSAGES = {
    MISMATCH: 'Les mots de passe ne correspondent pas.',
    INVALID_TOKEN: 'Ce lien est invalide ou expir\u00e9.',
    GENERIC: 'Une erreur est survenue. Veuillez r\u00e9essayer.',
};

const RULES = [
    { label: 'Au moins 8 caract\u00e8res',       test: (p) => p.length >= 8 },
    { label: 'Au moins 1 majuscule',              test: (p) => /[A-Z]/.test(p) },
    { label: 'Au moins 1 minuscule',              test: (p) => /[a-z]/.test(p) },
    { label: 'Au moins 1 caract\u00e8re sp\u00e9cial', test: (p) => /\W/.test(p) },
    { label: 'Au moins 1 nombre',                 test: (p) => /\d/.test(p) },
];

const eyeBtnStyle = {
    position: 'absolute',
    top: '50%',
    right: '8px',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    width: '20px',
    height: '20px',
};

const inputStyle = {
    width: '100%',
    height: '36px',
    borderRadius: '10px',
    padding: '0 36px 0 15px',
    fontSize: '13px',
    fontWeight: '400',
    backgroundColor: '#FFFFFF',
    boxSizing: 'border-box',
};

const ResetPassword = () => {
    const API_BASE_URL = 'https://dev-auth.apps.istor.io';
    const token = new URLSearchParams(window.location.search).get('token') ?? '';

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const isMobile = useMediaQuery('(max-width: 750px)');

    const passwordOk = RULES.every((r) => r.test(password));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        if (!passwordOk) return;
        if (password !== confirm) { setError('MISMATCH'); return; }
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE_URL}/auth/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password }),
            });
            if (!res.ok) setError('INVALID_TOKEN');
            else window.location.href = '/?reset=success';
        } catch {
            setError('GENERIC');
        } finally {
            setLoading(false);
        }
    };

    const errorBanner = (
        <div style={{ width: '100%', height: '36px', background: '#FFEDED', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#F46969', fontSize: '13px', fontWeight: '400', padding: '0 12px', boxSizing: 'border-box', textAlign: 'center' }}>
            {ERROR_MESSAGES[error] ?? ''}
        </div>
    );

    const newPasswordField = (
        <div style={{ position: 'relative', width: '100%' }}>
            <button type="button" className="eye-toggle" onClick={() => setShowPassword((p) => !p)} style={eyeBtnStyle} aria-label={showPassword ? 'Masquer' : 'Afficher'}>
                {showPassword ? <EyeOff /> : <EyeOn />}
            </button>
            <input
                className="ifield"
                style={inputStyle}
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Nouveau mot de passe"
                autoComplete="new-password"
                required
            />
        </div>
    );

    const confirmPasswordField = (
        <div style={{ position: 'relative', width: '100%' }}>
            <button type="button" className="eye-toggle" onClick={() => setShowConfirm((p) => !p)} style={eyeBtnStyle} aria-label={showConfirm ? 'Masquer' : 'Afficher'}>
                {showConfirm ? <EyeOff /> : <EyeOn />}
            </button>
            <input
                className="ifield"
                style={inputStyle}
                type={showConfirm ? 'text' : 'password'}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Confirmez le mot de passe"
                autoComplete="new-password"
                required
            />
        </div>
    );

    const reinitButton = (
        <button
            className="connexion"
            type="submit"
            disabled={loading}
            style={{ width: '100%', height: '36px', borderRadius: '10px', color: '#FFFFFF', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '13px', fontWeight: '600', cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.6 : 1 }}
        >
            {loading ? <div className="loading-spinner" /> : 'Réinitialisez votre mot de passe'}
        </button>
    );

    if (isMobile) {
        return (
            <form
                onSubmit={handleSubmit}
                style={{
                    width: '330px',
                    height: '517px', maxHeight: 'calc(100dvh - 40px)',
                    boxSizing: 'border-box',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '20px',
                    boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
                    padding: '20px 30px 30px 30px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}
            >
                {/* Haut : mini-mascotte + titre + texte court, aligné à gauche */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <img src={ministor} alt="istor" style={{ width: '60px', height: '60px', borderRadius: '50%', flexShrink: 0 }}/>
                        <div style={{ fontSize: '24px', fontWeight: '600', color: '#173C50', whiteSpace: 'pre-line' }}>{CONTENT.title}</div>
                    </div>
                    <div style={{
                        marginTop: '10px',
                        whiteSpace: 'pre-line',
                        fontSize: '13px',
                        fontWeight: '400',
                        color: '#173C50',
                        lineHeight: '19px',
                        textAlign: 'left',
                    }}>{CONTENT.short}</div>
                </div>

                {/* Bas : Nouveau → 10 → règles → 20 → Confirmez → 20 → bouton → 27 → Revenir */}
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    {error && <div style={{ marginBottom: '12px' }}>{errorBanner}</div>}
                    {newPasswordField}
                    <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {RULES.map((r) => (
                            <div key={r.label} style={{ fontSize: '10px', fontWeight: '400', color: r.test(password) ? '#67C856' : '#F46969', lineHeight: '1.4' }}>
                                {r.label}
                            </div>
                        ))}
                    </div>
                    <div style={{ marginTop: '20px' }}>{confirmPasswordField}</div>
                    <div style={{ marginTop: '20px' }}>{reinitButton}</div>
                    <div style={{ marginTop: '27px', display: 'flex', justifyContent: 'flex-start' }}>
                        <a href="/" className="retour">
                            <span className="retour-circle"><svg style={{ minWidth: '20px' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask-retour-reset-m" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                    <rect x="20" y="20" width="20" height="20" transform="rotate(-180 20 20)" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#mask-retour-reset-m)">
                                    <path d="M6.5 10L12.453 4L13.5 5.07713L8.61571 10L13.5 14.9229L12.453 16L6.5 10Z" fill="currentColor"/>
                                </g>
                            </svg>
                            </span>
                            Revenir à la connexion
                        </a>
                    </div>
                </div>
            </form>
        );
    }

    return (
        <div style={{ width: '700px', height: '450px', display: 'flex', overflow: 'hidden', borderRadius: '20px', boxShadow: '0px 10px 40px rgba(0,0,0,0.1)' }}>
            {/* Panneau gauche */}
            <div style={{ height: '100%', width: '360px', backgroundColor: '#173C50', position: 'relative', color: '#FFFFFF', flexShrink: 0 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', paddingLeft: '30px', position: 'absolute', top: '36px' }}>
                    <div style={{ fontSize: '24px', fontWeight: '600' }}>{CONTENT.title}</div>
                    <div style={{ whiteSpace: 'pre-line', fontSize: '13px', fontWeight: '400', lineHeight: '19px' }}>{CONTENT.message}</div>
                </div>
                <img style={{ position: 'absolute', bottom: 0, right: '-20px', width: '325px', height: '260px' }} src={istor} alt="istor" />
            </div>

            {/* Panneau droit */}
            <form
                onSubmit={handleSubmit}
                style={{ width: '340px', height: '100%', backgroundColor: '#FFFFFF', display: 'flex', flexDirection: 'column', padding: '20px 35px 36px 35px', alignItems: 'center', gap: '12px', boxSizing: 'border-box' }}
            >
                    <>
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            flexShrink: 0,
                        }}>
                            <a href="/" className="retour">
                                <span className="retour-circle"><svg style={{
                                    minWidth: '20px',
                                }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <mask id="mask-retour-reset" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                        <rect x="20" y="20" width="20" height="20" transform="rotate(-180 20 20)" fill="#D9D9D9"/>
                                    </mask>
                                    <g mask="url(#mask-retour-reset)">
                                        <path d="M6.5 10L12.453 4L13.5 5.07713L8.61571 10L13.5 14.9229L12.453 16L6.5 10Z" fill="currentColor"/>
                                    </g>
                                </svg>
                                </span>
                                Revenir à la connexion
                            </a>
                        </div>
                        {/* Bannière erreur */}
                        <div style={{ width: '100%', height: '36px', background: '#FFEDED', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#F46969', fontSize: '13px', fontWeight: '400', opacity: error ? 1 : 0, transition: 'opacity 0.1s ease', padding: '0 12px', boxSizing: 'border-box', textAlign: 'center' }}>
                            {ERROR_MESSAGES[error] ?? ''}
                        </div>

                        {/* Nouveau mot de passe */}
                        <div style={{ position: 'relative', width: '100%' }}>
                            <button type="button" className="eye-toggle" onClick={() => setShowPassword((p) => !p)} style={eyeBtnStyle} aria-label={showPassword ? 'Masquer' : 'Afficher'}>
                                {showPassword ? <EyeOff /> : <EyeOn />}
                            </button>
                            <input
                                className="ifield"
                                style={inputStyle}
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Nouveau mot de passe"
                                autoComplete="new-password"
                                required
                            />
                        </div>

                        {/* Règles de validation */}
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            {RULES.map((r) => (
                                <div key={r.label} style={{ fontSize: '10px', fontWeight: '500', color: r.test(password) ? '#67C856' : '#F46969', lineHeight: '1.4' }}>
                                    {r.label}
                                </div>
                            ))}
                        </div>

                        {/* Confirmer mot de passe */}
                        <div style={{ position: 'relative', width: '100%' }}>
                            <button type="button" className="eye-toggle" onClick={() => setShowConfirm((p) => !p)} style={eyeBtnStyle} aria-label={showConfirm ? 'Masquer' : 'Afficher'}>
                                {showConfirm ? <EyeOff /> : <EyeOn />}
                            </button>
                            <input
                                className="ifield"
                                style={inputStyle}
                                type={showConfirm ? 'text' : 'password'}
                                value={confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                placeholder="Confirmez le mot de passe"
                                autoComplete="new-password"
                                required
                            />
                        </div>

                        {/* Bouton */}
                        <button
                            className="connexion"
                            type="submit"
                            disabled={loading}
                            style={{ width: '100%', height: '36px', borderRadius: '10px', color: '#FFFFFF', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '13px', fontWeight: '600', cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.6 : 1, marginTop: '4px' }}
                        >
                            {loading ? <div className="loading-spinner" /> : 'R\u00e9initialisez votre mot de passe'}
                        </button>
                    </>
            </form>
        </div>
    );
};

export default ResetPassword;
